import moment from 'moment';
import PropTypes from 'prop-types';

const makeMomentPropType = (isRequired = false) => (props, propName, componentName) => (
    (props[propName] === undefined && !isRequired)
    || moment.isMoment(props[propName])
        ? null
        : new Error(`Invalid prop ${propName} supplied to ${componentName}. Expected moment.`));

// eslint-disable-next-line import/prefer-default-export
export const momentPropType = makeMomentPropType();
momentPropType.isRequired = makeMomentPropType(true);

export const columnsProptype = PropTypes.arrayOf(
    PropTypes.shape({
        id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired,
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        symbol: PropTypes.string
    })
);
